module.exports = __webpack_public_path__ + "static/media/instagram_button.5161f810.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/img/instagram_button.svg
// module id = 397
// module chunks = 2